/**
 * Vrai si l'utilisateur porte le rôle global ROLE_ADMIN.
 *
 * À distinguer de organizationRole === 'owner' (portée tenant, propre à une
 * organisation). L'espace admin est réservé aux ROLE_ADMIN globaux.
 */
export const isAdmin = (user) => Array.isArray(user?.roles) && user.roles.includes('ROLE_ADMIN')
